"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setResponsiveMode = exports.SET_RESPONSIVE_MODE = exports.setCurrentPage = exports.SET_CURRENT_PAGE = exports.fetchPois = exports.POIS_FAILURE = exports.POIS_SUCCESS = exports.POIS_REQUEST = exports.fetchStandCategories = exports.STAND_CATEGORIES_FAILURE = exports.STAND_CATEGORIES_SUCCESS = exports.STAND_CATEGORIES_REQUEST = exports.fetchZones = exports.ZONES_FAILURE = exports.ZONES_SUCCESS = exports.ZONES_REQUEST = exports.fetchParticipants = exports.PARTICIPANTS_FAILURE = exports.PARTICIPANTS_SUCCESS = exports.PARTICIPANTS_REQUEST = exports.fetchParticipantTypes = exports.PARTICIPANT_TYPES_FAILURE = exports.PARTICIPANT_TYPES_SUCCESS = exports.PARTICIPANT_TYPES_REQUEST = exports.fetchExhibitors = exports.EXHIBITORS_FAILURE = exports.EXHIBITORS_SUCCESS = exports.EXHIBITORS_REQUEST = exports.fetchWorkshops = exports.WORKSHOPS_FAILURE = exports.WORKSHOPS_SUCCESS = exports.WORKSHOPS_REQUEST = exports.fetchSponsors = exports.SPONSORS_FAILURE = exports.SPONSORS_SUCCESS = exports.SPONSORS_REQUEST = exports.fetchSpeakers = exports.SPEAKERS_FAILURE = exports.SPEAKERS_SUCCESS = exports.SPEAKERS_REQUEST = exports.fetchComposerSettings = exports.COMPOSER_SETTINGS_FAILURE = exports.COMPOSER_SETTINGS_SUCCESS = exports.COMPOSER_SETTINGS_REQUEST = exports.objectToQueryString = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _api = require("../middleware/api");
var _api2 = require("../helpers/api");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var objectToQueryString = exports.objectToQueryString = function objectToQueryString(obj) {
  return !!obj ? "?" + Object.keys(obj).reduce(function (res, k) {
    if (obj[k]) res.push(encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]));
    return res;
  }, []).join('&') : '';
};
var buildSpeakersEndpointParams = function buildSpeakersEndpointParams(state) {
  var extraParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return objectToQueryString(_extends({
    'offset_to_utc': true,
    'page[size]': (0, _api2.getPaginationSize)(8, state, 'speakerPaginationSize')
  }, extraParams));
};
var getSpeakersEndpoint = function getSpeakersEndpoint(params) {
  return function (state) {
    return "events/" + (0, _api2.getEventUri)(state) + "/speakers" + buildSpeakersEndpointParams(state, params);
  };
};
var getWorkshopsEndpoint = function getWorkshopsEndpoint(state) {
  return "events/" + (0, _api2.getEventUri)(state) + "/workshops?include=workshop_categories,speakers&offset_to_utc=true";
};
var getSponsorsEndpoint = function getSponsorsEndpoint(state) {
  return "events/" + (0, _api2.getEventUri)(state) + "/sponsors?include=category";
};
var getExhibitorsEndpoint = function getExhibitorsEndpoint(params) {
  return function (state) {
    return "events/" + (0, _api2.getEventUri)(state) + "/stand_reservations" + objectToQueryString(params);
  };
};
var getParticipantTypesEndpoint = function getParticipantTypesEndpoint(state) {
  if (!(0, _api2.getBusinessConference)(state)) {
    return null;
  }
  return "events/" + (0, _api2.getEventUri)(state) + "/business_conferences/" + (0, _api2.getBusinessConference)(state) + "/business_conference_participant_types";
};
var getParticipantsEndpoint = function getParticipantsEndpoint(params) {
  return function (state) {
    if (!(0, _api2.getBusinessConference)(state)) {
      return null;
    }
    return "events/" + (0, _api2.getEventUri)(state) + "/business_conferences/" + (0, _api2.getBusinessConference)(state) + "/business_conference_participants" + objectToQueryString(params);
  };
};
var getZonesEndpoint = function getZonesEndpoint(state) {
  return "events/" + (0, _api2.getEventUri)(state) + "/zones";
};
var getStandCategoriesEndpoint = function getStandCategoriesEndpoint(state) {
  return "events/" + (0, _api2.getEventUri)(state) + "/stand_categories";
};
var getPoisEndpoint = function getPoisEndpoint(state) {
  return "events/" + (0, _api2.getEventUri)(state) + "/pois";
};
var COMPOSER_SETTINGS_REQUEST = exports.COMPOSER_SETTINGS_REQUEST = 'COMPOSER_SETTINGS_REQUEST';
var COMPOSER_SETTINGS_SUCCESS = exports.COMPOSER_SETTINGS_SUCCESS = 'COMPOSER_SETTINGS_SUCCESS';
var COMPOSER_SETTINGS_FAILURE = exports.COMPOSER_SETTINGS_FAILURE = 'COMPOSER_SETTINGS_FAILURE';
var fetchComposerSettings = exports.fetchComposerSettings = function fetchComposerSettings(event_uri, params_json) {
  return _defineProperty({}, _api.CALL_API, {
    types: [COMPOSER_SETTINGS_REQUEST, COMPOSER_SETTINGS_SUCCESS, COMPOSER_SETTINGS_FAILURE],
    endpoint: "events/" + event_uri + "/composer_settings" + objectToQueryString(params_json)
  });
};
var SPEAKERS_REQUEST = exports.SPEAKERS_REQUEST = 'SPEAKERS_REQUEST';
var SPEAKERS_SUCCESS = exports.SPEAKERS_SUCCESS = 'SPEAKERS_SUCCESS';
var SPEAKERS_FAILURE = exports.SPEAKERS_FAILURE = 'SPEAKERS_FAILURE';
var fetchSpeakers = exports.fetchSpeakers = function fetchSpeakers(endpoint, params) {
  return _defineProperty({}, _api.CALL_API, {
    types: [SPEAKERS_REQUEST, SPEAKERS_SUCCESS, SPEAKERS_FAILURE],
    endpoint: endpoint || getSpeakersEndpoint(params)
  });
};
var SPONSORS_REQUEST = exports.SPONSORS_REQUEST = 'SPONSORS_REQUEST';
var SPONSORS_SUCCESS = exports.SPONSORS_SUCCESS = 'SPONSORS_SUCCESS';
var SPONSORS_FAILURE = exports.SPONSORS_FAILURE = 'SPONSORS_FAILURE';
var fetchSponsors = exports.fetchSponsors = function fetchSponsors(endpoint) {
  return _defineProperty({}, _api.CALL_API, {
    types: [SPONSORS_REQUEST, SPONSORS_SUCCESS, SPONSORS_FAILURE],
    endpoint: endpoint || getSponsorsEndpoint,
    fetchAllPages: true
  });
};
var WORKSHOPS_REQUEST = exports.WORKSHOPS_REQUEST = 'WORKSHOPS_REQUEST';
var WORKSHOPS_SUCCESS = exports.WORKSHOPS_SUCCESS = 'WORKSHOPS_SUCCESS';
var WORKSHOPS_FAILURE = exports.WORKSHOPS_FAILURE = 'WORKSHOPS_FAILURE';
var fetchWorkshops = exports.fetchWorkshops = function fetchWorkshops(endpoint) {
  return _defineProperty({}, _api.CALL_API, {
    types: [WORKSHOPS_REQUEST, WORKSHOPS_SUCCESS, WORKSHOPS_FAILURE],
    endpoint: endpoint || getWorkshopsEndpoint,
    fetchAllPages: true
  });
};
var EXHIBITORS_REQUEST = exports.EXHIBITORS_REQUEST = 'EXHIBITORS_REQUEST';
var EXHIBITORS_SUCCESS = exports.EXHIBITORS_SUCCESS = 'EXHIBITORS_SUCCESS';
var EXHIBITORS_FAILURE = exports.EXHIBITORS_FAILURE = 'EXHIBITORS_FAILURE';
var fetchExhibitors = exports.fetchExhibitors = function fetchExhibitors(endpoint, params) {
  var completeParams = !!params ? _extends({}, params, {
    city_as_hash: true
  }) : {
    city_as_hash: true
  };
  return _defineProperty({}, _api.CALL_API, {
    types: [EXHIBITORS_REQUEST, EXHIBITORS_SUCCESS, EXHIBITORS_FAILURE],
    endpoint: endpoint || getExhibitorsEndpoint(completeParams)
  });
};
var PARTICIPANT_TYPES_REQUEST = exports.PARTICIPANT_TYPES_REQUEST = 'PARTICIPANT_TYPES_REQUEST';
var PARTICIPANT_TYPES_SUCCESS = exports.PARTICIPANT_TYPES_SUCCESS = 'PARTICIPANT_TYPES_SUCCESS';
var PARTICIPANT_TYPES_FAILURE = exports.PARTICIPANT_TYPES_FAILURE = 'PARTICIPANT_TYPES_FAILURE';
var fetchParticipantTypes = exports.fetchParticipantTypes = function fetchParticipantTypes(endpoint) {
  return function (dispatch, getState) {
    var participantTypesEndpoint = getParticipantTypesEndpoint(getState());
    if (!!participantTypesEndpoint) {
      dispatch(_defineProperty({}, _api.CALL_API, {
        types: [PARTICIPANT_TYPES_REQUEST, PARTICIPANT_TYPES_SUCCESS, PARTICIPANT_TYPES_FAILURE],
        endpoint: endpoint || participantTypesEndpoint,
        fetchAllPages: true
      }));
    }
  };
};
var PARTICIPANTS_REQUEST = exports.PARTICIPANTS_REQUEST = 'PARTICIPANTS_REQUEST';
var PARTICIPANTS_SUCCESS = exports.PARTICIPANTS_SUCCESS = 'PARTICIPANTS_SUCCESS';
var PARTICIPANTS_FAILURE = exports.PARTICIPANTS_FAILURE = 'PARTICIPANTS_FAILURE';
var fetchParticipants = exports.fetchParticipants = function fetchParticipants(endpoint, params) {
  return function (dispatch, getState) {
    var participantEndpoint = getParticipantsEndpoint(params)(getState());
    if (!!participantEndpoint) {
      dispatch(_defineProperty({}, _api.CALL_API, {
        types: [PARTICIPANTS_REQUEST, PARTICIPANTS_SUCCESS, PARTICIPANTS_FAILURE],
        endpoint: endpoint || participantEndpoint
      }));
    }
  };
};
var ZONES_REQUEST = exports.ZONES_REQUEST = 'ZONES_REQUEST';
var ZONES_SUCCESS = exports.ZONES_SUCCESS = 'ZONES_SUCCESS';
var ZONES_FAILURE = exports.ZONES_FAILURE = 'ZONES_FAILURE';
var fetchZones = exports.fetchZones = function fetchZones(endpoint) {
  return _defineProperty({}, _api.CALL_API, {
    types: [ZONES_REQUEST, ZONES_SUCCESS, ZONES_FAILURE],
    endpoint: endpoint || getZonesEndpoint,
    fetchAllPages: true
  });
};
var STAND_CATEGORIES_REQUEST = exports.STAND_CATEGORIES_REQUEST = 'STAND_CATEGORIES_REQUEST';
var STAND_CATEGORIES_SUCCESS = exports.STAND_CATEGORIES_SUCCESS = 'STAND_CATEGORIES_SUCCESS';
var STAND_CATEGORIES_FAILURE = exports.STAND_CATEGORIES_FAILURE = 'STAND_CATEGORIES_FAILURE';
var fetchStandCategories = exports.fetchStandCategories = function fetchStandCategories(endpoint) {
  return _defineProperty({}, _api.CALL_API, {
    types: [STAND_CATEGORIES_REQUEST, STAND_CATEGORIES_SUCCESS, STAND_CATEGORIES_FAILURE],
    endpoint: endpoint || getStandCategoriesEndpoint,
    fetchAllPages: true
  });
};
var POIS_REQUEST = exports.POIS_REQUEST = 'POIS_REQUEST';
var POIS_SUCCESS = exports.POIS_SUCCESS = 'POIS_SUCCESS';
var POIS_FAILURE = exports.POIS_FAILURE = 'POIS_FAILURE';
var fetchPois = exports.fetchPois = function fetchPois(endpoint) {
  return _defineProperty({}, _api.CALL_API, {
    types: [POIS_REQUEST, POIS_SUCCESS, POIS_FAILURE],
    endpoint: endpoint || getPoisEndpoint,
    fetchAllPages: true
  });
};
var SET_CURRENT_PAGE = exports.SET_CURRENT_PAGE = 'SET_CURRENT_PAGE';
var setCurrentPage = exports.setCurrentPage = function setCurrentPage(id) {
  return {
    type: SET_CURRENT_PAGE,
    id: id
  };
};
var SET_RESPONSIVE_MODE = exports.SET_RESPONSIVE_MODE = 'SET_RESPONSIVE_MODE';
var setResponsiveMode = exports.setResponsiveMode = function setResponsiveMode(responsiveMode) {
  return function (dispatch, getState) {
    dispatch({
      type: SET_RESPONSIVE_MODE,
      responsiveMode: responsiveMode
    });
  };
};